<a href="#main-content" class="skip-link">Zum Hauptinhalt springen</a>

@if (showChrome()) {
  <app-header />
}

<main id="main-content" class="main-content" tabindex="-1">
  <router-outlet />
</main>

@if (showChrome()) {
  <app-footer />
}

<!-- Globaler Toast-Host für Live-Updates (RealtimeToastService). Bewusst auf
     Root-Ebene, damit Realtime-Events auch außerhalb der Konto-/Admin-Shells
     sichtbar sind. Pages mit eigenem <p-toast> hängen über einen anderen
     MessageService nicht zusammen — wir nutzen den globalen Service. -->
<p-toast position="top-right" />

<!-- Cookie-Banner bewusst außerhalb der showChrome-Blöcke: muss auf jeder Seite
     erscheinen (auch Login/Onboarding), bevor irgendein Tracking startet. -->
<app-cookie-banner />
